import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
const languages = [{
  name: 'Luxembourgish',
  level: 'Native'
}, {
  name: 'English',
  level: 'Fluent'
}, {
  name: 'French',
  level: 'Fluent'
}, {
  name: 'German',
  level: 'Fluent'
}];
export function About() {
  return <section id="about" className="bg-white py-24 lg:py-32" data-id="element-16" data-mp="2yt7yrsy5lryo">
      <div className="max-w-content mx-auto px-6 lg:px-10 grid lg:grid-cols-[1.2fr_0.8fr] gap-16" data-id="element-17" data-mp="33rhxgdj37ap1">
        <div data-id="element-18" data-mp="38q2z8hdzm2fl">
          <SectionHeading eyebrow="01 — About" title="A Global Leadership Identity" data-id="element-19" data-mp="38pt4kghzz73k" />
          <p className="mt-6 text-base leading-relaxed text-slate-600 max-w-xl" data-id="element-20" data-mp="3dhba7huytvuv">
            Stephanie Meyer is an international media and broadcasting executive with more than 25 years of
            leadership experience spanning Europe, North America, Latin America, and Asia. Her career
            reflects a rare range: equally fluent in boardroom strategy and the operational realities of
            global broadcast delivery.
          </p>
          <p className="mt-5 text-base leading-relaxed text-slate-600 max-w-xl" data-id="element-21" data-mp="2lssappgyrcxn">
            Her leadership is grounded in disciplined execution and commercial clarity — aligning strategy,
            people, and technology without losing sight of long-term enterprise value. It is a philosophy
            built for organizations navigating structural change, not just steady-state growth.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-slate-50 border border-slate-200 p-8" data-id="element-22" data-mp="34jt7c6um2we1">
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-gold-dark" data-id="element-23" data-mp="2qo7mmbveuyrf">Languages</span>
          <ul className="mt-6 space-y-4" data-id="element-24" data-mp="3o7iuu1vimahg">
            {languages.map(lang => <li key={lang.name} className="flex items-center justify-between border-b border-slate-200 pb-3 last:border-b-0 last:pb-0" data-id="element-25" data-mp="3jdo96swcnlfq">
                <span className="text-sm font-medium text-navy" data-id="element-26" data-mp="b4nc8d28ubi7">{lang.name}</span>
                <span className="text-xs uppercase tracking-wide text-slate-500" data-id="element-27" data-mp="3tiwcg9t9vtyq">{lang.level}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}